import React, { useEffect, useState } from 'react'
import Chart from "react-apexcharts";
import { urlApi } from '../../../api/url.api';
import { postApi } from '../../../api/call.api';
import { dateIntoYYYY_MM_DD } from '../../../utils/dateTimeConverter';
import DateRange from '../../../components/DateRange/DateRange';
import DateFilterInfoPopup from '../../../components/Popover/DateFilterInfoPopup';
import DropDown from '../../../components/DropDown/DropDown';

const AttributionGraph = () => {

    const [selected, setSelected] = useState(2);
    const [date, setDate] = useState({ startDate: '', endDate: '' });
    const [firstFilter, setFirstFilter] = useState('Ad Medium');
    const [secondFilter, setSecondFilter] = useState('Click');

    const [series, setSeries] = useState([{
        name: 'Email',
        data: [0, 0, 0, 0, 0, 0, 0]
    }, {
        name: 'Google Ads',
        data: [0, 0, 0, 0, 0, 0, 0]
    }, {
        name: 'Meta Ads',
        data: [0, 0, 0, 0, 0, 0, 0]
    }, {
        name: 'Others',
        data: [0, 0, 0, 0, 0, 0, 0]
    }, {
        name: 'SMS',
        data: [0, 0, 0, 0, 0, 0, 0]
    }, {
        name: 'Twitter Ads',
        data: [0, 0, 0, 0, 0, 0, 0]
    }, {
        name: 'WhatsApp',
        data: [0, 0, 0, 0, 0, 0, 0]
    }, {
        name: 'YouTube Ads',
        data: [0, 0, 0, 0, 0, 0, 0]
    }])

    const [options, setOptions] = useState({
        chart: {
            type: 'bar',
            height: 350,
            stacked: true,
            toolbar: {
                show: false
            },
            zoom: {
                enabled: false,
                allowMouseWheelZoom: false,
            }
        },
        responsive: [{
            breakpoint: 480,
            options: {
                legend: {
                    position: 'bottom',
                    offsetX: -10,
                    offsetY: 0
                }
            }
        }],
        plotOptions: {
            bar: {
                horizontal: false,
                borderRadius: 10,
                borderRadiusApplication: 'end', // 'around', 'end'
                borderRadiusWhenStacked: 'last', // 'all', 'last'
                dataLabels: {
                    total: {
                        enabled: false,
                        style: {
                            fontSize: '13px',
                            fontWeight: 900
                        }
                    }
                }
            },
        },
        xaxis: {
            categories: [],
        },
        legend: {
            position: 'bottom',
            offsetY: 10
        },
        fill: {
            opacity: 1
        }
    });

    const firstFilterList = [{
        id: 1,
        name: 'Ad Medium'
    }, {
        id: 2,
        name: 'Creative Type'
    }]

    const secondFilterList = [{
        id: 1,
        name: 'Click'
    }, {
        id: 2,
        name: 'Cost'
    }, {
        id: 3,
        name: 'Installs'
    }, {
        id: 4,
        name: 'Registrations'
    }]

    const getData = async () => {

        let firstFilterLocal = firstFilterList?.find(item => item?.name == firstFilter);
        let secondFilterLocal = secondFilterList?.find(item => item?.name == secondFilter);

        let postData = {
            filter: selected,
            firstFilter: firstFilterLocal?.id,
            secondFilter: secondFilterLocal?.id
        }
        if (selected == 3) {
            postData["startDate"] = dateIntoYYYY_MM_DD(date.startDate);
            postData["endDate"] = dateIntoYYYY_MM_DD(date.endDate);
        }

        let resp = await postApi(postData, urlApi?.getAttributionGraphData);

        if (resp.responseCode === 200) {

            let localEmail = [];
            let localGoogleAds = [];
            let localMetaAds = [];
            let localOthers = [];
            let localSms = [];
            let localTwitterAds = [];
            let localWhatsApp = [];
            let localYouTubeAds = [];

            let localAudio = [];
            let localCarousel = [];
            let localGif = [];
            let localHtml5Banner = [];
            let localImage = [];
            let localInteractive = [];
            let localText = [];
            let localVideo = [];


            let localX = [];

            for (const item of resp?.data) {
                localX.push(item?.date);

                if (firstFilter == "Ad Medium") {
                    localEmail.push(item?.email || 0);
                    localGoogleAds.push(item?.googleAds || 0);
                    localMetaAds.push(item?.metaAds || 0);
                    localOthers.push(item?.others || 0);
                    localSms.push(item?.sms || 0);
                    localTwitterAds.push(item?.twitterAds || 0);
                    localWhatsApp.push(item?.whatsApp || 0);
                    localYouTubeAds.push(item?.youtubeAds || 0);
                }
                if (firstFilter == "Creative Type") {
                    localAudio.push(item?.audio || 0);
                    localCarousel.push(item?.caraousel || 0);
                    localOthers.push(item?.others || 0);
                    localGif.push(item?.gif || 0);
                    localHtml5Banner.push(item?.html5Banner || 0);
                    localImage.push(item?.image || 0);
                    localInteractive.push(item?.interactive || 0);
                    localText.push(item?.text || 0);
                    localVideo.push(item?.video || 0);
                }
            }

            if (firstFilter == "Ad Medium") {
                setSeries([{
                    name: 'Email',
                    data: localEmail
                }, {
                    name: 'Google Ads',
                    data: localGoogleAds
                }, {
                    name: 'Meta Ads',
                    data: localMetaAds
                }, {
                    name: 'Others',
                    data: localOthers
                }, {
                    name: 'SMS',
                    data: localSms
                }, {
                    name: 'Twitter Ads',
                    data: localTwitterAds
                }, {
                    name: 'WhatsApp',
                    data: localWhatsApp
                }, {
                    name: 'YouTube Ads',
                    data: localYouTubeAds
                }])
            }

            if (firstFilter == "Creative Type") {
                setSeries([{
                    name: 'Audio',
                    data: localAudio
                }, {
                    name: 'Carousel',
                    data: localCarousel
                }, {
                    name: 'Others',
                    data: localOthers
                }, {
                    name: 'Gif',
                    data: localGif
                }, {
                    name: 'HTML5 Banner',
                    data: localHtml5Banner
                }, {
                    name: 'Image',
                    data: localImage
                }, {
                    name: 'Interactive',
                    data: localInteractive
                }, {
                    name: 'Text',
                    data: localText
                }, {
                    name: 'Video',
                    data: localVideo
                }])
            }

            setOptions({ ...options, xaxis: { ...options.xaxis, categories: localX, type: selected == 1 ? 'time' : 'datetime' } });

        } else {
            setSeries([{
                name: 'Email',
                data: [0, 0, 0, 0, 0, 0, 0]
            }, {
                name: 'Google Ads',
                data: [0, 0, 0, 0, 0, 0, 0]
            }, {
                name: 'Meta Ads',
                data: [0, 0, 0, 0, 0, 0, 0]
            }, {
                name: 'Others',
                data: [0, 0, 0, 0, 0, 0, 0]
            }, {
                name: 'SMS',
                data: [0, 0, 0, 0, 0, 0, 0]
            }, {
                name: 'Twitter Ads',
                data: [0, 0, 0, 0, 0, 0, 0]
            }, {
                name: 'WhatsApp',
                data: [0, 0, 0, 0, 0, 0, 0]
            }, {
                name: 'YouTube Ads',
                data: [0, 0, 0, 0, 0, 0, 0]
            }])
        }
    }

    useEffect(() => {
        if (selected == 3 && !date?.startDate) {
            return
        }
        getData();
    }, [selected, date, firstFilter, secondFilter])

    function onDateChange(p) {
        let newDate = { startDate: p.startDate._d, endDate: p.endDate._d }
        setDate(newDate)
    }

    function handleOnChange(value) {
        setSelected(parseInt(value));
        if (value !== 3) {
            setDate({ startDate: '', endDate: '' })
        }
    }

    return (
        <div className='mb-4 bg-white p-2 rounded-lg'>
            <div className="flex items-center gap-2 flex-wrap">
                <p className='mb-0 text-md font-bold text-[var(--grey)] me-auto'>Attribution Graph</p>
                <DropDown title={"Category"} list={firstFilterList?.map(item => item?.name)} defaultValue={firstFilterList?.find(item => item?.name == firstFilter)?.name} onSelect={(name) => setFirstFilter(name)} />
                <DropDown title={"Attribution"} list={secondFilterList?.map(item => item?.name)} defaultValue={secondFilterList?.find(item => item?.name == secondFilter)?.name} onSelect={(name) => setSecondFilter(name)} />
                <div className='flex gap-2'>
                    <select name="" id="" className='form-control form-control-sm' defaultValue={selected} onChange={(e) => { handleOnChange(e?.target?.value) }}>
                        <option value="2">Last 7 Days</option>
                        <option value="3">Custom</option>
                    </select>
                </div>
                {selected == 3 && <DateRange onApplyClick={(date) => onDateChange(date)} date={date} />}
                {date?.startDate && <DateFilterInfoPopup />}
            </div>
            <Chart options={options} series={series} height={'360px'} type="bar" />
        </div>
    )
}

export default AttributionGraph